// extracted by mini-css-extract-plugin
module.exports = {"FooterMenuItems":"FooterMenuItems_FooterMenuItems__3-bUh"};